import { trim } from 'lodash'

const COOKIE_DELIMITER = ';'
const COOKIE_VALUE_DELIMITER = '='

export const getCookie = (key: string, defaultValue: string) => {
  try {
    const cookies = document.cookie.split(COOKIE_DELIMITER)
    const foundCookieString = cookies.find(cookieString => trim(cookieString.split(COOKIE_VALUE_DELIMITER)[0]) === key)

    if (!foundCookieString) {
      return defaultValue
    }

    const [, value] = foundCookieString.split(COOKIE_VALUE_DELIMITER)

    return value ?? defaultValue
  } catch {
    return defaultValue
  }
}
